export { Icon } from './Icon';
export type { IconProps, IconName, IconSize, IconColor } from './Icon';
